import React, {
  FunctionComponent as FC,
  useContext,
  useRef,
  useState,
  useEffect,
  useLayoutEffect,
} from "react";
import { FunnelContext } from "@components/funnel/builder/FunnelContext";
import {
  ImutationParams,
  updateSite,
} from "@components/funnel/hooks/useSiteUpdate";
import {
  $BaseURLText,
  ShortNameInputMaxCharacter,
  $ShortNameInput,
} from "./FunnelHeader.sc";
import { useAlert } from "react-alert";
import { useMutation } from "react-query";
import { colors } from "@styles/colors";
import HoverTab from "@atoms/HoverTab";

const SlugEditor: FC = ({}) => {
  const alert = useAlert();
  const ref = useRef(null);
  const { funnelData, updateFrontend } = useContext(FunnelContext);
  const mutation = useMutation((params: ImutationParams) => updateSite(params));
  const { site_attributes, page_attributes } = funnelData.backend;
  const preferredSlug = page_attributes.homepage ? site_attributes.slug : page_attributes.custom_slug;

  function handleSlug(e) {
    let slug = e.target.value;
    if (slug !== preferredSlug) {
      updateSlug(slug);
    }
  }

  function updateSlug(value) {
    let attributes = {
      id: page_attributes.homepage ? site_attributes.id : page_attributes.custom_slug,
      page_id: page_attributes.id,
      site_uuid: site_attributes.uuid,
    };
    if (page_attributes.homepage) {
      attributes['site'] = { slug: value };
    } else {
      attributes['page'] = { custom_slug: value };
    }
    mutation.mutate(
      attributes,
      {
        onSuccess: (responseData) => {
          funnelData.backend = responseData;
          updateFrontend();
          alert.success(<p>Save was successful</p>);
        },
        onError: () => {
          ref.current.value = preferredSlug;
          setText(preferredSlug);
          alert.error(
            <>
              <h3>Your shortname could not be changed</h3>
              <p>Please enter an available shortname.</p>
            </>
          );
        },
      }
    );
  }

  const calculateSlugWidth = (): string => {
    const baseURLWidth = document.querySelector(
      ".edit-url-wrapper p"
    ).clientWidth;
    const urlBarWidth = document.querySelector(
      ".funnel-header-container"
    ).clientWidth;
    return `${urlBarWidth - baseURLWidth - 210}px`;
  };

  const [slugInputMaxWidth, setSlugInputMaxWidth] = useState<string>("0px");
  const [text, setText] = useState<string>(preferredSlug);

  useEffect(() => {
    setSlugInputMaxWidth(calculateSlugWidth);
  }, []);

  useEffect(() => {
    setText(preferredSlug);
  }, [preferredSlug]);

  useLayoutEffect(() => {
    function updateSize() {
      setSlugInputMaxWidth(calculateSlugWidth);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return (
    <>
      <$BaseURLText>{site_attributes.base_url}</$BaseURLText>
      {(!Boolean(site_attributes.domain) || (Boolean(site_attributes.domain) && Boolean(site_attributes.domain_is_shared))) && (
        <HoverTab
          fieldName="Short Name"
          styling={{ display: "inline-block", lineHeight: "36px" }}
        >
          <$ShortNameInput
            id="shortName"
            ref={ref}
            value={text}
            autoComplete="off"
            style={{ width: slugInputMaxWidth }}
            onChange={(e) => setText(e.target.value)}
            onBlur={(e) => handleSlug(e)}
            data-place="bottom"
            data-effect="solid"
            data-background-color={colors.darkBlue}
            data-tip={text}
            data-tip-disable={text.length < ShortNameInputMaxCharacter}
            data-arrow-color="transparent"
          />
        </HoverTab>
      )}
    </>
  );
};

export default SlugEditor;
